export default __webpack_public_path__ + "static/not-found-0be9a3045a13b1441637d891ddbbbacb.jpg";